define.alias("shared/components/shared/button/upgrade", "media/components/shared/button/upgrade");